import { render, staticRenderFns } from "./TransformationPackage.vue?vue&type=template&id=287a0460&scoped=true&"
import script from "./TransformationPackage.vue?vue&type=script&lang=js&"
export * from "./TransformationPackage.vue?vue&type=script&lang=js&"
import style0 from "./TransformationPackage.vue?vue&type=style&index=0&id=287a0460&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287a0460",
  null
  
)

export default component.exports